import _extends from "@babel/runtime/helpers/esm/extends";
import { useEffect, useRef, useState } from "react";
import { RxExecutor } from "rx-executor";
export const useAsyncExecutor = (executeFn$, config) => {
  const [, reRender] = useState(0);
  const asyncExecutorRef = useRef(RxExecutor.create(executeFn$, _extends({}, config, {
    onExecutionChange: execution => {
      reRender(Math.random());
    }
  })));
  const asyncExecutor = asyncExecutorRef.current;
  const asyncExecutionExecuteRef = useRef(asyncExecutor.execute);
  const execute = asyncExecutionExecuteRef.current;
  const execution = asyncExecutor.execution;
  const getExecutionRef = useRef(() => {
    return asyncExecutor.execution;
  });
  const getExecution = getExecutionRef.current;
  const retryRef = useRef(asyncExecutor.retry);
  const retry = retryRef.current;
  const setDataRef = useRef(asyncExecutor.setData);
  const setData = setDataRef.current;
  useEffect(() => {
    const subscription = asyncExecutor.concurrentExecutor.execution$.subscribe();
    return () => {
      subscription.unsubscribe();
    };
  }, [asyncExecutor.concurrentExecutor.execution$]);
  return {
    executions: asyncExecutor.executions,
    status: execution.state.status,
    isLoading: execution.isLoading,
    isError: execution.isError,
    isSuccess: execution.isSuccess,
    data: execution.data,
    error: execution.error,
    errors: execution.errors,
    execution,
    execute,
    getExecution,
    retry,
    setData
  };
};